import { Component, ViewChild } from "@angular/core";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { CrudComponent } from "src/app/components/shared/cruds/crud.component";
import { Condition } from "src/app/models/custom-types";
import { FilterEvent } from "src/app/models/filter";
import { ListColumn } from "src/app/models/list-columns.model";
import { TiposServicioDTO } from "src/app/models/tipo-servicio.dto";
import { LayoutsService } from "src/app/services/layouts.service";
import { Filter } from "src/app/shared/classes/filter";
import { TiposServiciosService } from "./tipos-servicios.service";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { TipoServiciosDrawerForm } from "./drawer-form/drawer-form.component";
import { DrawerService } from "src/app/services/drawer.service";

@Component({
  selector: "app-tipos-servicios",
  templateUrl: "./tipos-servicios.component.html",
  styles: [],
})
export class TiposServiciosComponent extends CrudComponent<TiposServicioDTO> {
  columnId: string = "IdTipoServicio";
  public columns: ListColumn[] = [
    {
      name: "Desc",
      property: "Descripcion",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];
  @ViewChild(CardTableComponent, { static: true })
  public tableComp: CardTableComponent;

  filtro: string = "";
  inactivos: boolean = false;
  realdata: TiposServicioDTO[];

  constructor(
    public service: TiposServiciosService,
    private layoutService: LayoutsService,
    public alerts: AlertasSwalService,
        public drawer: DrawerService,
  ) {
    super(service, alerts);
  }

  ngOnInit(): void {
    this.loadRecords();
    this.layoutService.changeHeader("Tipos de servicios");
    this.filter = new Filter<TiposServicioDTO>(
      this.conditions,
      this.columns,
      true
    );
    this.filter.setColumnActive(this.columnActive);
  }
  loadRecords() {
    this.service.get().subscribe(
      (resultData) => {
        this.realdata = resultData;
        this.filter.setDataTable(this.realdata, this.tableComp);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  //#region Filter

  public filter: Filter<TiposServicioDTO>;
  public conditions: Condition<TiposServicioDTO> = {
    Descripcion: (o, f) =>
      (o.Descripcion ?? "").toLocaleLowerCase().indexOf(f) > -1,
  };

  filterdata(e: FilterEvent) {
    this.filter.filterdata(e, this.realdata, this.tableComp);
  }

  //#endregion Filter



    openUser() {
      const drawerRef = this.drawer.open({
        component: TipoServiciosDrawerForm,
        data: { mode: "create", value: {} },
        width: "500px",
        title: "Tipos de servicios",
        classes: "bg-blueGray-100",
        actions: [
          {
            label: "Cancel",
            action: () => this.drawer.close(),
            buttonClass: "bg-red-600",
          },
          {
            label: "Guardar",
            action: (component: TipoServiciosDrawerForm) => component.saveOver(),
          },
        ],
      });

      drawerRef.afterClosed$.subscribe((result: any) => {
        this.saveForm(result.data);
      });
    }

    override openEdit(value: any) {
      const drawerRef = this.drawer.open({
        component: TipoServiciosDrawerForm,
        data: { mode: "update", value: value },
        width: "500px",
        title: "Tipos de servicios",
        classes: "bg-blueGray-100",
        actions: [
          {
            label: "Cancel",
            action: () => this.drawer.close(),
            buttonClass: "bg-red-600",
          },
          {
            label: "Actualizar",
            action: (component: TipoServiciosDrawerForm) => component.saveOver(),
          },
        ],
      });

      drawerRef.afterClosed$.subscribe((result: any) => {
        this.saveForm(result.data);
      });
    }
    public tableActionsCC = [
      {
        label: "Nuevo",
        icon: "plus",
        className:
          "text-xs font-bold uppercase px-3 py-2 rounded shadow hover:shadow-md bg-blueGray-600 text-white disabled:opacity-50",
        action: () => this.openUser(),
      },
    ];
}
